import HeaderMeta from 'components/headerMeta/HeaderMeta';
import Footer from 'components/layout/Footer';
import { buildPageBreadcrumb } from 'untils/jsonLdSchemas';
import { JetCardMain } from './JetCard.style';
import Content from './components/Content';
import Header from './components/Header';

const JetCard = () => {
  return (
    <JetCardMain>
      <HeaderMeta type="jetCard" jsonLd={[buildPageBreadcrumb('Jet Card', '/jetCard')]} />
      <Header />
      <Content />
      <Footer />
    </JetCardMain>
  );
};
export default JetCard;
